import { useSyncExternalStore } from 'react';

export interface UndoOffer {
  message: string;
  undo: () => Promise<unknown>;
}

let current: (UndoOffer & { id: number }) | null = null;
let seq = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Offer an Undo for something just removed. The bar goes after a few seconds; the same restore stays available
 *  from Recently removed or Trash until the soft-delete period ends. */
export function offerUndo(offer: UndoOffer): void {
  current = { ...offer, id: ++seq };
  emit();
}

export function clearUndo(): void {
  current = null;
  emit();
}

export function useUndoOffer() {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => current);
}
